
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/custom-overlays",
      function () {
        return require("private-next-pages/docs/custom-overlays.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/custom-overlays"])
      });
    }
  